/**
 * Cookie utility for managing browser cookies
 */
const Cookies = (function() {
    // Private helper functions could go here

    // Public interface
    return {
        /**
         * Sets a cookie with the given name, value, and options
         * @param {string} name - The cookie name
         * @param {string} value - The cookie value
         * @param {Object} options - Cookie options (days, path, secure, sameSite, domain)
         */
        set: function(name, value, options = {}) {
            const defaultOptions = {
                days: null,
                path: '/',
                secure: location.protocol === 'https:',
                sameSite: 'Lax'
            };

            const cookieOptions = { ...defaultOptions, ...options };

            let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value || '')}`;

            if (cookieOptions.days !== null) {
                const date = new Date();
                date.setTime(date.getTime() + (cookieOptions.days * 24 * 60 * 60 * 1000));
                cookieString += `; expires=${date.toUTCString()}`;
            }

            cookieString += `; path=${cookieOptions.path}`;
            if (cookieOptions.secure) cookieString += '; secure';
            if (cookieOptions.sameSite) cookieString += `; sameSite=${cookieOptions.sameSite}`;
            if (cookieOptions.domain) cookieString += `; domain=${cookieOptions.domain}`;

            document.cookie = cookieString;
        },

        /**
         * Gets a cookie value by name
         * @param {string} name - The cookie name
         * @returns {string|null} The cookie value or null if not found
         */
        get: function(name) {
            const nameEQ = `${encodeURIComponent(name)}=`;
            const cookies = document.cookie.split(';');

            for (const cookie of cookies) {
                const trimmedCookie = cookie.trim();
                if (trimmedCookie.indexOf(nameEQ) === 0) {
                    return decodeURIComponent(trimmedCookie.substring(nameEQ.length));
                }
            }
            return null;
        },

        /**
         * Gets all cookies with a specific prefix
         * @param {string} prefix - The cookie name prefix
         * @returns {Object} Object with cookie names and values
         */
        getWithPrefix: function(prefix) {
            const cookies = document.cookie.split(';');
            const result = {};

            for (const cookie of cookies) {
                const [name, value] = cookie.trim().split('=');
                if (name.startsWith(prefix)) {
                    result[decodeURIComponent(name)] = decodeURIComponent(value);
                }
            }

            return result;
        },

        /**
         * Deletes all cookies with a specific prefix
         * @param {string} prefix - The cookie name prefix
         * @param {Object} options - Cookie deletion options (path, domain)
         */
        deleteWithPrefix: function(prefix, options = {}) {
            const cookies = this.getWithPrefix(prefix);
            const cookieOptions = {
                days: -1,
                ...options
            };

            for (const name in cookies) {
                this.set(name, '', cookieOptions);
            }
        },

        /**
         * Deletes a single cookie
         * @param {string} name - The cookie name
         * @param {Object} options - Cookie deletion options (path, domain)
         */
        delete: function(name, options = {}) {
            this.set(name, '', { days: -1, ...options });
        }
    };
})();